'use strict';
var videoUtils = require('../util/videos');
var utils = require('../util/utils');

module.exports = {
    initEvents: function () {
        // events will be init'd on load
        var $inlineBtn = $('.video-inline-link');
        var $heroComponent = $('.vf-wrapper');
        $heroComponent.on('click', function (e) {
            var $currentVideo = $(e.currentTarget);
            if ($currentVideo.hasClass('paused')) {
                videoUtils.playPauseVideo($currentVideo, 'play');
                $currentVideo.removeClass('paused');
                $inlineBtn.removeClass('paused');
                $inlineBtn.addClass('playing');
            } else {
                videoUtils.playPauseVideo($currentVideo, 'pause');
                $currentVideo.addClass('paused');
                $inlineBtn.addClass('paused');
                $inlineBtn.removeClass('playing');
            }
        });

        // hide the poster image to reveal the inline video
        $inlineBtn.on('click', function (e) {
            var $parent = $(e.currentTarget).parent();
            var $posterImg = $parent.find('.photo-tile-container');
            var $vfWrapper = $parent.find('.vf-wrapper, .inline-video');
            $posterImg.addClass('disable-poster-image');
            $vfWrapper.trigger('click');
        });

        // IE11 fix for object-fit
        // will fix all images, not just heros
        utils.ieObjectFitFix();
    },
    initJumpLinks: function () {
        $('.jump-link').on('click', function (e) {
            e.preventDefault();
            var anchorTarget = $(e.currentTarget).attr('href');
            utils.scrollBrowser($(anchorTarget).offset().top - 40);
        });
    },
    initVideoComponents: function () {
        let $videoComponents = $('[class$="videoComponent"]');
        $videoComponents.each(function () {
            let $videoComponent = $(this);
            videoUtils.initPosterImgEvents($videoComponent);
        });
    }
};
